import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { HEADERS } from "@/utils/applicationConstants";

const baseUrl = "/api/";

/**
 * Account RTK Query service.
 *
 * Uses a Content-Type–agnostic prepareHeaders so that fetchBaseQuery
 * auto-sets "application/json" for plain-object bodies and leaves
 * Content-Type unset for FormData bodies (avatar / logo uploads).
 *
 * Endpoints are injected from individual files in ./endpoints/.
 */
export const accountService = createApi({
  reducerPath: "accountService",
  tagTypes: ["Account", "Company"],
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const { currentCompany } = getState().currentUser;

      headers.set(HEADERS.TENANT_ID, currentCompany.companyId);
      headers.set(HEADERS.APP_ID, process.env.NEXT_PUBLIC_APP_ID);
      headers.set(HEADERS.VERSION_ID, process.env.NEXT_PUBLIC_APP_VERSION);

      if (process.env.NODE_ENV === "development" && process.env.NEXT_PUBLIC_CLIENT_IP) {
        headers.set("x-forwarded-for", process.env.NEXT_PUBLIC_CLIENT_IP);
      }

      return headers;
    },
  }),
  endpoints: () => ({}),
});

